<template>
  <div>
    <SideBar />
    <HeaderData />
    <v-row align="center">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="9">
            <v-text-field v-model="search" label="Search" style="width: 300px" class="mt-5 ml-4" single-line
              hide-details></v-text-field>
          </v-col>
          <v-col cols="3" class="text-right">
            <v-btn @click="openDialog" class="mt-5 mr-3"  style="height: 40px; width: 110px; margin-right:150px" color="primary" rounded="xl">
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogVisible" max-width="800px">
      <v-card>
        <v-toolbar color="#0277BD" :style="{ fontSize: '25px', paddingLeft:'20px'}" dark flat>
          {{ formData.id ? "Edit" : " Add" }} Category </v-toolbar>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-text>
            <v-text-field v-model="formData.name" :rules="nameRules" label="Name" required>
            </v-text-field>
          <!-- <CategoriesDropdown :initialData="{ category: formData.parentCategoryId }" :categoryId="formData.id"
              @category-selected="handleCategorySelected"></CategoriesDropdown> -->
            <div class="mt-5 ml-1">
              <v-switch v-model="formData.is_active" color="primary" inset label="Active" ></v-switch>
            </div>
            <div class="mb-1">
              <span>Description</span>
            </div>
            <Editor v-model="formData.description" editorStyle="height: 320px" />
            <div v-if="v$.formData.description.$error" class="mt-2 ml-5 error-message">Description is required!</div>
          </v-card-text>
          <div class="mx-4">
            <!-- <v-file-input 
              v-model="fileInput"
              :key="fileInputKey"
              accept="image/*" 
              label="Image Input" 
              @change="handleFileUpload"
              ></v-file-input> -->
              <!-- v-model="fileInput" 
              -->
              <label class="file-input-label mb-2" style="background-color: #0277BD; height:42px;">
                Upload Image
                <input 
                  type="file" 
                  :key="fileInputKey"
                  accept="image/*" 
                  label="Image Input" 
                  @change="handleFileUpload"
                  class="file-input"
                  >
              </label>
              <div v-if="isImageSelected && selectedImage && selectedImage.length < 1" class="mb-2 ml-5 error-message">
                  Image is required!
              </div>
              <v-card variant="tonal" v-if="selectedImage && selectedImage.length">
                <div  class="d-flex justify-space-between my-3 mx-2">
                  <div class="mt-2">
                    {{ selectedImage[0].name }}
                  </div>
                    <div>
                      <v-btn
                      @click="removeImage"
                        color="red"
                        >Remove</v-btn
                      >
                    </div>
                </div>
              </v-card>
          </div>
          <v-card-actions>
            <v-btn v-if="!isLoading" color="primary" @click="validate">{{
              formData.id ? "Update" : "Save"
            }}</v-btn>
            <span v-if="isLoading" class="mr-2">Please Wait</span> 
            <v-progress-circular v-if="isLoading" color="primary" indeterminate></v-progress-circular>

            <v-btn v-if="!isLoading" @click="closeDialog">Cancel</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDeleteDialogVisible" persistent max-width="400px">
      <v-card>
        <v-card-title class="headline mt-4">Confirm Delete</v-card-title>
        <v-card-text>Are you sure you want to delete this Category?</v-card-text>
        <v-card-text>Note:- Deleting category also deleted all related categories too.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!isLoading" color="darken-1" text @click="confirmDeleteDialogVisible = false">Cancel</v-btn>
          <v-btn v-if="!isLoading" color="red darken-1" text @click="confirmDelete">Delete</v-btn>
          <span v-if="isLoading" class="mr-2">Please Wait</span> 
          <v-progress-circular v-if="isLoading" color="primary" indeterminate></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmActiveDialogVisible" persistent max-width="400px">
      <v-card>
        <v-card-title class="headline mt-4">Confirm In-Active Category</v-card-title>
        <v-card-text
          >Are you sure you want to inactive this Category?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!isLoading"
            color="darken-1"
            text
            @click="cancelActive"
            >Cancel</v-btn
          >
          <v-btn v-if="!isLoading" color="red darken-1" text @click="toggleActiveStatus">In Active</v-btn>
          <span v-if="isLoading" class="mr-2">Please Wait</span> 
          <v-progress-circular v-if="isLoading" color="primary" indeterminate></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table :headers="headers" :items="categories.data" class="mt-2">
      <template v-slot:item.description="{ item }">
        <ReadMore v-if="item.description" :text="item.description" :maxLength="55" :title="'Category Description'"></ReadMore>
      </template>
      <template #bottom>
        <v-pagination v-model="pagination.currentPage" :length="pagination.lastPage" :total-visible="6"
          @input="handlePageChange($event)"></v-pagination>
      </template>
      <template v-slot:item.image="{ item }">
        <img :src="getImageUrl(item.image)" alt="" class="image-set" />
      </template>

      <template v-slot:item.actions="{ item }" >
        <v-icon color="blue" @click="editCategory(item)">mdi-pencil</v-icon>
        <v-icon class="ml-3" color="red" @click="deleteCategory(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:item.is_active="{ item }">
        <v-switch
          v-model="item.is_active"
          @click.prevent="changeActiveValue(item)"
          color="primary"
        ></v-switch>
      </template>
    </v-data-table>
  </div>
  <v-snackbar v-model="snackbarVisible" location="top right">
    {{ snackbarMessage }}
  </v-snackbar>
</template>
<script>
import SideBar from "../components/SideBar.vue";
import CategoriesDropdown from "@/components/CategoriesDropdown.vue";
import { mapActions } from "vuex";
import ConfirmationDialog from "../components/Common/ConfirmationDialog.vue";
import HeaderData from "@/components/HeaderData.vue";
import Editor from "primevue/editor";
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import ReadMore from "./ReadMore.vue";
import axios from 'axios';

export default {
  components: {
    CategoriesDropdown,
    SideBar,
    ConfirmationDialog,
    HeaderData,
    Editor,
    ReadMore
  },

  data() {
    return {
      search: "",
      dialogVisible: false,
      isLoading: false,
      isActiveSwitch: false,
      valid: true,
      name: "",
      nameRules: [(v) => !!v || "Name is required!"],
      description: "",
      descriptionRules: [(v) => !!v || "Description is required!"],
      formData: {
        id: "",
        name: "",
        description: "",
        is_active: false,
        // parentCategoryId: "",
        image: null,
      },
      headers: [
        { text: "Name", title: "Name", value: "name", sortable: true },
        {
          text: "description",
          title: "Description",
          value: "description",
          sortable: true,
        },
        // {
        //   text: "parentCategoryName",
        //   title: "Parent category",
        //   value: "parentCategoryName",
        //   sortable: true,
        // },
        {
          text: "is_active",
          title: "Active",
          value: "is_active",
          sortable: true,     
        },
        {
          text: "image",
          title: "Image",
          value: "image",
        },
        {
          text: "Actions",
          title: "Actions",
          value: "actions",
          sortable: false,
        },
      ],
      confirmDeleteDialogVisible: false,
      confirmActiveDialogVisible: false,
      selectedFile: [],
      selectedImage: [],
      fileInput: null,
      fileInputKey: 0,
      isImageSelected: false,
      imagesData: [],
      confirmDeleteDialogVisible: false,
      selectedCategory: null,
      sortBy: [],
      sortDesc: [],
      snackbarVisible: false,
      snackbarMessage: "",
      pagination: {
        lastPage: null,
        currentPage: 1,
        total: null,
        perPage: 10,
      },
    };
  },

  validations() {
    return {
      formData: {
        description: { required },
      }
    }
  },

  setup() {
    const v$ = useVuelidate();
    return { v$ };
  },

  created() {
    this.fetchCategories(
      this.pagination.currentPage,
      this.pagination.perPage,
      this.search
    );
    console.log("this.pagination.currentPage", this.pagination.currentPage);
    console.log("this.pagination.perPage", this.pagination.perPage);
  },

  watch: {
    "pagination.currentPage"(newPage) {
      if (typeof newPage !== "undefined") {
        console.log(`Page changed to: ${newPage}`);
        this.fetchCategories(newPage, this.pagination.perPage, this.search);
      }
    },

    search(newSearch, oldSearch) {
      if (newSearch !== oldSearch) {
        this.pagination.currentPage = 1;
        this.$nextTick(() => {
          this.fetchCategories(
            this.pagination.currentPage,
            this.pagination.perPage,
            newSearch
          );
        });
      }
    },
  },

  beforeRouteLeave() {
    console.log("innnnn");
    this.pagination.currentPage = 1;
  },

  computed: {
    categories() {
      console.log("Categories in component", this.$store.state.categories);
      const categoriesData = this.$store.state.categories;
      console.log("categoriesData", categoriesData);

      this.pagination.lastPage = categoriesData.last_page;
      this.pagination.currentPage = categoriesData.current_page;
      this.pagination.perPage = categoriesData.per_page;
      this.pagination.total = categoriesData.total;
      return this.$store.state.categories;
    },
  },

  methods: {
    ...mapActions(["fetchItems"]),
    async fetchCategories(page, perPage, search) {
      console.log(
        `Fetching categories with page=${page}, perPage=${perPage}, search='${search}'`
      );
      search = search || "";
      await this.$store.dispatch("fetchItems", {
        page: page,
        perPage: perPage,
        search: search,
      });
    },

    getImageUrl(imageJson) {
      try {
        const imageData = JSON.parse(imageJson) ?? [];
        return imageData[0]?.url;
      } catch (error) {
        console.error("Error parsing image JSON:", error);
        return "#";
      }
    },

    cancelActive() {
      this.confirmActiveDialogVisible = false;
      this.fetchCategories();
    },

    changeActiveValue(item) {
      this.selectedCategory = item;
      if(item.is_active == true) {
        this.confirmActiveDialogVisible = true;
      } else {
        this.toggleActiveStatus();
      }
    },

    async toggleActiveStatus() {
      let item = this.selectedCategory;
      this.isLoading = true;
      try {
        let formData = {
          id: item.id,
          is_active: !item.is_active,
        }
        const response = await axios.post(
          `${process.env.VUE_APP_URL}/api/category-change-active`,
          formData
        );
        this.fetchCategories(
          this.pagination.currentPage,
          this.pagination.perPage,
          this.search
        );
        this.confirmActiveDialogVisible = false;
        this.snackbarMessage = "Category updated successfully";
        this.snackbarVisible = true;
      } catch (error) {
        this.confirmActiveDialogVisible = false;
        this.isLoading = false;
        console.error("Error toggling category active status:", error);
      } finally {
        this.confirmActiveDialogVisible = false;
        this.isLoading = false;
      }
    },

    stripTags(htmlString) {
      const doc = new DOMParser().parseFromString(htmlString, "text/html");
      return doc.body.textContent || "";
    },

    handleCategorySelected(categoryId) {
      console.log("Category selected:", categoryId);
      // this.formData.parentCategoryId = categoryId;
      // this.categoryValid = !!selectedCategory;
      // this.checkFormValidity();
    },

    async validate() {
      this.isImageSelected = true;
      const validate = await this.$refs.form.validate();
      await this.v$.$validate();
      if (validate.valid && !this.v$.$error && this.selectedImage.length) {
        this.saveCategory();
      }
    },
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.formData = {
        id: "",
        name: "",
        description: "",
        is_active: false,
        // parentCategoryId: "",
        image: null,
      };
      this.selectedFile = [];
      this.selectedImage = [];
      this.isImageSelected = false;
      if (this.v$) {
        this.v$.$reset();
      }
    },
    handlePageChange(newPage) {
      this.pagination.currentPage = newPage;
      this.fetchCategories(
        this.pagination.currentPage,
        this.pagination.perPage,
        this.search
      );
    },

    handleFileUpload(event) {
      var selectedFiles = event.target.files || event;
      this.selectedFile = [];
      this.selectedImage = [];

      for (let i = 0; i < selectedFiles.length; i++) {
        // console.log(selectedFiles[i]);
        this.selectedFile.push(selectedFiles[i]);
        this.selectedImage.push({
          name: selectedFiles[i].name
        });
      }
      // this.selectedFile = event.target.files[0];
    },

    removeImage() {
      this.isImageSelected = true;
      this.selectedFile = [];
      this.selectedImage = [];
      this.fileInput = null;
      this.fileInputKey++;
    },

    async saveCategory() {
      this.isLoading = true;
      let formData = {
        name: this.formData.name,
        description: this.formData.description,
        is_active: this.formData.is_active,
        // parentCategoryId: this.formData.parentCategoryId || "",
      };

      if (this.formData.id) {
        formData.id = this.formData.id;
      }

      if (this.selectedFile && this.selectedFile.length) {
        formData.image = this.selectedFile;
      }

      if (formData.id) {
        await this.$store.dispatch("editItem", formData);
        this.fetchCategories(
          this.pagination.currentPage,
          this.pagination.perPage,
          this.search
        );
      } else {
        await this.$store.dispatch("addItem", {
          formData: formData,
          page: this.pagination.currentPage,
          perPage: this.pagination.perPage,
        });
      }

      try {
        this.selectedFile = [];
        this.isLoading = false;
        this.snackbarMessage = this.formData.id
          ? "Category updated successfully!"
          : "Category added successfully!";
        this.snackbarVisible = true;
        this.closeDialog();
      } catch (error) {
        this.isLoading = false;
        console.error("Error saving category:", error);
        this.snackbarMessage = "Error occurred while saving the category.";
        this.snackbarVisible = true;
      }
    },

    editCategory(item) {
      console.log("Update Category:", item);
      this.formData = {
        id: item.id,
        name: item.name,
        description: item.description,
        is_active: item.is_active,
        // parentCategoryId: item.parentCategoryId,
        image: null,
      };
      console.log("Form data:", this.formData);
      this.selectedImage = JSON.parse(item.image);
      this.selectedFile = [];
      this.dialogVisible = true;
    },

    deleteCategory(item) {
      this.selectedCategory = item;
      this.confirmDeleteDialogVisible = true;
    },
    async confirmDelete() {
      try {
        this.isLoading = true;
        const categoryId = this.selectedCategory.id;
        await this.$store.dispatch("deleteItem", categoryId);
        this.$store.commit("DELETE_CATEGORY", categoryId);
        this.confirmDeleteDialogVisible = false;
        this.pagination.currentPage = 1;
        this.selectedCategory = null;
        this.isLoading = false;
        this.snackbarMessage = "Category deleted successfully!";
        this.snackbarVisible = true;
      } catch (error) {
        this.isLoading = false;
        console.error("Error deleting category:", error);
        this.snackbarMessage = "Error occurred while deleting the category.";
        this.snackbarVisible = true;
      }
    },
  },
};
</script>
<style scoped>
.truncate-text {
  display: inline-block; 
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.image-set {
  margin-top: 5px;
  max-height: 85px;
  max-width: 85px;
}

.error-message {
  font-size: small;
  color: #B00020;
}

.file-input-label {
  background-color: #f6f6f6;
  /* color: white; */
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: inline-block;
  color: white;
}

.file-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.v-table--density-default {
    --v-table-header-height: 60px;
    --v-table-row-height: 75px;
}
</style>
